import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_CSVS_QUERY_KEY } from './useGetCsvs';

import CSVService, { CSVUploadDto } from '@/services/CSVService';

export function useCreateCsv() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (csvUploadDto: CSVUploadDto) =>
      CSVService.createCsv(csvUploadDto),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: GET_CSVS_QUERY_KEY(),
      });
    },
  });

  return {
    createCsv: mutateAsync,
    isLoading: isPending,
    error,
  };
}
